import { Component, OnInit } from '@angular/core';
import { WorkspaceService } from '../../workspace.service';
import { Router } from "@angular/router";
import { statusModel } from '../http-post-request-object-classes/statusModel';
import { terminateModel } from '../http-post-request-object-classes/terminateModel';
import { Subscription } from 'rxjs/Subscription';
import * as moment from 'moment';
import { orderingModel } from '../http-post-request-object-classes/orderingModel';
import { extendModel } from '../http-post-request-object-classes/extendModel';
import { uploadModel } from '../http-post-request-object-classes/uploadModel';
import { listModel } from '../http-post-request-object-classes/listModel';
import { downloadFileModel } from '../http-post-request-object-classes/downloadFileModel';
import { loginModel } from '../http-post-request-object-classes/loginModel';
import { connectVMModel } from '../http-post-request-object-classes/connectVMModel';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  regionsArray: any = ['N.Virginia','Sydney'];
  constructor(public dataService: WorkspaceService, public router: Router) { }
  showAllMachine: boolean = false;
  ordersForIframe: any;
  tableData: any;
  captureText: string;
  activeTableData: any = [];
  inactiveTableData: any = [];
  loggedUser;
  showModal = false;
  extendOrder = false;
  extendOrTerminateLabel = "Extend"
  isExtend = true;
  interval;
  usermail;
  userPassword;
  statusModel = new statusModel('', '', [])
  orderIdArray = [];
  updatingOrderId;
  terminateModel = new terminateModel('', '', '')
  subscription: Subscription
  warningIssueTimer: Subscription
  deleteOrderLoader = false;
  OrderingModalSpinner = false;
  RebootingingModalSpinner = false;
  PETArray = [];
  SPECTArray = [];
  PREVIEWArray = [];
  machines: any;
  cfg: any;
  mac: any;
  // specificPETArray = []; /* Specific machine versions for each machine */
  // specificSPECTArray = [];
  specificMachineVersionArray = [];
  disableInitially = true;
  disableDropdown = true;
  selMachine;
  orderingModel = new orderingModel('', '', '', '', '', '', '', '', '', '', '','');
  extendModel = new extendModel('', '', '', '', '')
  extendTerminateLoaderMessage;
  orderSuccess = false;
  orderFailed = false;
  extensionFailed = false;
  extensionsucess = false;
  sessionSelectionError = false
  sessionSelectionErrorMessage = ''
  sessionTimeOK = false;
  endSelectionError = false;
  endSelectionErrorMessage = ''
  endTimeOk = false
  inactiveTableLocSessTime = [];
  activeTableLocSessTime = [];
  activeTableEndSessTime = [];
  inactiveTableEndSessTime = [];
  extensionTerminationMessage = '';
  extensionFailReasonMessage = '';
  editModalHeading = '';
  activeTableDataCopy = [];
  inactiveTableDataCopy = [];
  generalError = false;
  generalMessage = '';
  DropdownVal = '';
  mobileView = false;
  tooltipPosition = ''
  /** To store the end time on clicking update button */
  updatingOrderEndTimeLocalFormat = '' as any;
  updatingOrderEndTimeDate = '' as any;
  currentOrderEndTime = '' as any;

  /* Mobile stylesheet variables */
  mobileTableRowId = ''; // id of table row to fetched inside drawer
  mobileTableRowEndTime = '' as any;

  /** Theme */
  theme = '' as any;

  /* Order time in UTC in format YYYY-MM-DD HH:mm:ss */
  orderPresentTime = '' as any;

  /* Local times in format YYYY-MM-DD HH:mm:ss z */
  localOrderTime = '' as any;
  localProvisionTime = '' as any;
  localTerminationTime = '' as any;

  localExtensionTime = '' as any;

  uploadModel = new uploadModel('', '', '', '', '');

  uploadedOrderId = '' as any;
  secondUploadData = '' as any;
  uploadFileStatus = 'Uploading file ...' as any;
  uploadFileModelVisible = false;
  uploadFileStatusIcon = '' as any;
  progressValue = '' as any;
  progressUploadedFileName = '' as any;

  listModel = new listModel('', '', '');

  presignUrlOfXMLList = '' as any;
  orderEditModalData = '' as any;
  orderEditModalDataId = '' as any;
  orderEditModalDataEndTime = '' as any;
  orderEditModal = false;
  orderEditModalIndex = '' as any;

  downloadListModal = false;
  listOfFiles = [] as any;

  showDownloadFetchSpinner = false;

  downloadFileModel = new downloadFileModel('', '', '', '');
  clickedOrderId = '' as any;

  multipleFileUploadModelVisible = false;
  uploadFileModalWidth = '100%';
  uploadFileModalHeight = '100%';
  // Upload file empty state message
  uploadFileEmptyStateVisible = false;
  // Upload process started indicator
  uploadStarted = false;
  fileUploadArray = [{}] as any;
  // presigned url fetching status storing array
  firstFileUploadProcessArray = [{ status: 'Default' }] as any;
  fileUploadProcessArray = [{ progressValue: '0', success: false }] as any;

  fetchAndReadyToUploadStatus = '' as any;
  hideMultipleFileUploadButton = false;
  fileUploadURLArray = [];

  hideRemoveLink = false;

  fileUploadSuccessStatusCounter = 0 as any;
  uploadComplete = false;
  numberOfUploadedFiles = 0;
  totalNumberOfFiles = 0;
  uploadRadialProgressValue = 0 as any;
  realFileUploadStatusCounter = 0 as any;

  apple = [];

  showStartDownloadModal = false;
  downloadingFileStatus = '' as any;

  showDownloadSpinner = false;
  downloadSuccess = false;

  selectedNumberOfOrders = '1' as any;
  selectedRegions = '' as any;
  repeatedStatusCheckModel = new loginModel('', '');
  firstMenuItemActive = true;

  displayActiveTableDesktop: boolean = false;
  orderEditOption = [false, false, false, false, false];
  connectModalDialog = true;
  connectModalDialogVisible
  connectModalDialogMessageObtained = false;
  connectVMData = new connectVMModel('', '', '');
  connectModalMessage = ``;
  connectModalURL = ``;
  intermediateConnectModalMessage = ``;
  connectModalDialogError = false;
  userList: any[] = [];
  getUserName(order) {
    if (this.captureText !== '') {
      if (localStorage.getItem('userList')) {
        let newData = null;
        let item = JSON.parse(localStorage.getItem('userList'));
        if (Array.isArray(item)) {
          item.push({ id: order.id, value: this.captureText });
          newData = item;
        }
        else {
          newData = [item, { id: order.id, value: this.captureText }];
        }
        localStorage.setItem('userList', JSON.stringify(newData));
      }
      else {
        localStorage.setItem('userList', JSON.stringify({ id: order.id, value: this.captureText }));
      }
    }
  }
  setUserName(order, value) {
    this.captureText = value;
  }
  // getUserName(order, value) {
  //   this.userList.push({ id: order.id, value: value });
  //   localStorage.setItem('userList', JSON.stringify(this.userList));
  // }
  showOrderEditModal(data, index) {
    this.uncheckAllOrderEditOptions();
    this.orderEditModal = true;
    this.orderEditModalData = data;
    this.orderEditModalIndex = index;
  }
  editModal(id, endTime) {
    // closing the order-edit modal on click of update button
    this.orderEditModal = false
    this.extendOrder = true;
    this.updatingOrderId = id;
    this.updatingOrderEndTimeLocalFormat = endTime;
    this.updatingOrderEndTimeDate = new Date(this.updatingOrderEndTimeLocalFormat);
    this.currentOrderEndTime = moment(this.updatingOrderEndTimeDate).format('MMMM D YYYY, hh:mm:ss a');
    let drawer = document.querySelector('.update-drawer') as any;
    drawer.visible = false;
    // this.selectedcfg = row.children[0].innerText;
    // let progressRow = row.children[1].innerText;
    // let sessionTimeRow = row.children[2].innerText;
    // let endTimeRow = row.children[3].innerText;
  }
  upload(orderId) {
    // closing the order-edit modal on click of upload button
    this.orderEditModal = false;
    this.progressValue = '0';
    this.uploadFileStatus = '';
    this.progressUploadedFileName = '';
    this.uploadedOrderId = orderId;
    this.multipleFileUploadModelVisible = true;
    this.uploadFileEmptyStateVisible = true;
    let drawer = document.querySelector('.update-drawer') as any;
    drawer.visible = false;
  }

  // getReboot(orderId) {
  //   // closing the order-edit modal on click of upload button
  //   this.orderEditModal = false;
  //   this.progressValue = '0';
  //   this.uploadFileStatus = '';
  //   this.progressUploadedFileName = '';
  //   this.uploadedOrderId = orderId;
  //   this.multipleFileUploadModelVisible = true;
  //   this.uploadFileEmptyStateVisible = true;
  //   let drawer = document.querySelector('.update-drawer') as any;
  //   drawer.visible = false;
  // }

  // Browse files and upload them
  browseFiles() {
    let fileUploadInput = document.getElementById('fileUploader') as any;
    this.resetFileUploadValues();
    fileUploadInput.click();
  }
  fileUploadProcessStart(event) {
    let fileUploader = document.getElementById('fileUploader') as any;
    if (fileUploader.files.length === 0) {
      this.uploadFileEmptyStateVisible = true;
      return;
    }
    else if (fileUploader.value === '') {
      this.uploadFileEmptyStateVisible = true;
    }
    else {
      this.uploadFileEmptyStateVisible = false;
    }
    this.fileUploadArray = Array.from(fileUploader.files);
    this.firstFileUploadProcessArray.length = this.fileUploadArray.length;
    // creating not yet started messages
    for (let i = 0; i < this.firstFileUploadProcessArray.length; i++) {
      this.firstFileUploadProcessArray[i] = {} as any;
      this.firstFileUploadProcessArray[i].status = "Not yet started";
      this.fileUploadProcessArray[i] = {} as any;
      this.fileUploadProcessArray[i].progressValue = '0';
      this.fileUploadProcessArray[i].success = false;
    }
    // fileUploadObject.filename = fileUploader.files[0].name;
    // fileUploadObject.order_id = this.uploadedOrderId;
    // fileUploadObject.content_type = fileUploader.files[0].type;
    // fileUploadObject.mail = this.usermail;
    // fileUploadObject.passw = this.userPassword;
    // this.uploadModel = fileUploadObject;
    // this.uploadFileModelVisible = true;
    // this.dataService.upload(this.uploadModel)
    // .subscribe(data => {
    //   let receivedData = data as any;
    //   this.processReceivedDataAfterUpload(receivedData);
    //   this.uploadSecondTime(receivedData.presigned_URL);
    // })
  }
  removeFileFromArray(index) {
    this.firstFileUploadProcessArray = [{ status: '' }] as any;
    this.firstFileUploadProcessArray = [{ progressValue: '0', success: false }] as any;
    for (let i = 0; i < this.fileUploadArray.length - 1; i++) {
      this.firstFileUploadProcessArray[i] = {} as any;
      this.firstFileUploadProcessArray[i].status = "Not yet started";
      this.fileUploadProcessArray[i] = {} as any;
      this.fileUploadProcessArray[i].progressValue = '0';
      this.fileUploadProcessArray[i].success = false;
    }
    this.fileUploadArray.splice(index, 1);
    this.firstFileUploadProcessArray.length = this.fileUploadArray.length;

    for (let i = 0; i < this.firstFileUploadProcessArray.length; i++) {
      this.firstFileUploadProcessArray[i] = {} as any;
      this.firstFileUploadProcessArray[i].status = "Not yet started";
      this.fileUploadProcessArray[i] = {} as any;
      this.fileUploadProcessArray[i].progressValue = '0';
      this.fileUploadProcessArray[i].success = false;
    }
  }
  fetchStorageLocations() {
    // this.uploadStarted = true;
    const numberOfFiles = this.fileUploadArray.length;
    this.fetchAndReadyToUploadStatus = 'Please wait as we fetch the storage locations of your files';
    this.hideRemoveLink = true;
    for (let i = 0; i < numberOfFiles; i++) {
      this.firstFileUploadProcessArray[i].status = 'Fetching Storage Location';
      let fileUploadObject = {} as any;
      fileUploadObject.filename = this.fileUploadArray[i].name;
      fileUploadObject.order_id = this.uploadedOrderId;
      fileUploadObject.content_type = this.fileUploadArray[i].type;
      fileUploadObject.mail = this.usermail;
      fileUploadObject.passw = this.userPassword;
      this.uploadModel = fileUploadObject;
      this.dataService.upload(this.uploadModel)
        .subscribe(data => {
          let receivedData = data as any;
          if (receivedData.status === 'Success') {
            this.fileUploadURLArray[i] = receivedData.presigned_URL;
            this.firstFileUploadProcessArray[i].status = 'Successfully Fetched Storage Location';
            ++this.fileUploadSuccessStatusCounter;
            if (this.fileUploadSuccessStatusCounter === numberOfFiles) {
              this.fetchAndReadyToUploadStatus = 'Successfully fetched all storage locations.';
              this.hideMultipleFileUploadButton = true;
              this.startRealFileUpload();
            }
          }
        },
          error => {
            this.firstFileUploadProcessArray[i].status = 'Could not Fetch Storage Location';
            this.fetchAndReadyToUploadStatus = `Could not fetch storage locations of all files. Consider retrying by clicking below button or
            reduce the number of files uploaded at a time`;
            this.hideRemoveLink = false;
          });
    }
    // setTimeout(() => {
    //   let successStatusCounter = 0;
    //   for (let i = 0; i < numberOfFiles; i++) {
    //     if (this.firstFileUploadProcessArray[i].status === 'Successfully Fetched Storage Location') {
    //       successStatusCounter++;
    //     }
    //   }
    //   if (successStatusCounter === numberOfFiles) {
    //     this.fetchAndReadyToUploadStatus = 'Successfully fetched all storage locations.';
    //     this.hideMultipleFileUploadButton = true;
    //     this.startRealFileUpload();
    //   }
    //   else {
    //     this.fetchAndReadyToUploadStatus = `Could not fetch storage locations of all files. Consider retrying by clicking below button or
    //       reduce the number of files uploaded at a time`;
    //     this.hideRemoveLink = false;
    //   }
    // }, 15000);
  }
  startRealFileUpload() {
    this.uploadStarted = true;
    this.fetchAndReadyToUploadStatus = 'Uploading your files';
    let numberOfFiles = this.fileUploadArray.length;
    for (let i = 0; i < numberOfFiles; i++) {
      this.fileUploadProcessArray[i] = {} as any;
      this.dataService.uploadSecondTime(this.fileUploadArray[i], this.fileUploadURLArray[i])
        .subscribe(data => {
          let receivedData = data as any;
          if (typeof (receivedData) === 'object') {
            this.fileUploadProcessArray[i].progressValue = receivedData[1];
            if (receivedData[1] === 100) {
              this.fileUploadProcessArray[i].success = true;
              ++this.realFileUploadStatusCounter;
              this.numberOfUploadedFiles = this.realFileUploadStatusCounter;
              this.totalNumberOfFiles = numberOfFiles;
              this.uploadRadialProgressValue = ((this.numberOfUploadedFiles / numberOfFiles) * 100).toFixed(0);
              if (this.realFileUploadStatusCounter === numberOfFiles) {
                this.uploadComplete = true;
              }
            }
          }
        })
    }
  }
  resetFileUploadValues() {
    let fileUploadInput = document.getElementById('fileUploader') as any;
    fileUploadInput.value = [];
    this.hideMultipleFileUploadButton = false;
    this.firstFileUploadProcessArray = [{ status: '' }];
    this.fetchAndReadyToUploadStatus = 'Click on Upload Button to upload files after you have decided on your files';
    this.fileUploadArray = [];
    this.uploadFileEmptyStateVisible = true;
    this.uploadStarted = false;
    this.fileUploadProcessArray = [{ progressValue: '0', success: false }];
    this.fileUploadURLArray = [];
    this.hideRemoveLink = false;
    this.fileUploadSuccessStatusCounter = 0;
    this.uploadComplete = false;
    this.numberOfUploadedFiles = 0;
    this.totalNumberOfFiles = 0;
    this.uploadRadialProgressValue = 0 as any;
    this.realFileUploadStatusCounter = 0 as any;
  }
  uploadSecondTime(url) {
    this.dataService.uploadSecondTime(this.secondUploadData, url)
      .subscribe(data => {
        let receivedData = data as any;
        if (typeof (receivedData) === 'object') {
          this.progressValue = receivedData[1];
          this.progressUploadedFileName = `Uploading ${receivedData[0]}`;
        }
        this.uploadFileStatus = data;
        if (data === `File "${this.secondUploadData.name}" was completely uploaded!`) {
          this.uploadFileStatusIcon = 'success';
          this.progressUploadedFileName = ``;
        }
      })
  }
  downloadFile(orderId) {
    this.orderEditModal = false;
    this.downloadListModal = true;
    this.showDownloadFetchSpinner = true;
    this.listOfFiles = [];
    this.getListOfFilesInS3(orderId);
    let drawer = document.querySelector('.update-drawer') as any;
    drawer.visible = false;
  }
  getListOfFilesInS3(orderId) {
    this.listModel.order_id = orderId;
    this.listModel.mail = this.usermail;
    this.listModel.passw = this.userPassword;
    this.dataService.getListOfFilesFromS3(this.listModel)
      .subscribe(data => {
        let receivedData = data as any;
        let receivedList = receivedData.presigned_URL;
        if (receivedList === null) {
          this.listOfFiles = [];
        }
        else {
          this.listOfFiles = receivedList;
        }
        this.showDownloadFetchSpinner = false;
        this.clickedOrderId = orderId;
      })
  }

  getReboot(orderId) {
    this.orderEditModal = false;
    this.RebootingingModalSpinner = true;
    this.listModel.order_id = orderId;
    this.listModel.mail = this.usermail;
    this.listModel.passw = this.userPassword;
    this.dataService.reboot(this.listModel)
      .subscribe(data => {
        this.RebootingingModalSpinner = false;
        let receivedData = data as any;
        let receivedList = receivedData.status;
        if (receivedList === "Success") {
          alert("Successfully Rebooted");
        }
        else {
          alert("Reboot Failed!");
        }

      })
  }

  downloadIndividualFiles(filename) {
    this.showStartDownloadModal = true;
    this.downloadSuccess = false;
    this.downloadingFileStatus = `Please wait as we fetch ${filename}`;
    this.showDownloadSpinner = true;
    this.downloadFileModel.mail = this.usermail;
    this.downloadFileModel.passw = this.userPassword;
    this.downloadFileModel.filename = filename;
    this.downloadFileModel.order_id = this.clickedOrderId;
    let newTabOpeningExtensions = ['png', 'jpeg', 'jpg', 'mp4', 'pdf', 'doc', 'html'];
    let thisFileExtension = filename.toString().split('.')[1];
    let opensInNewTab = false;
    for (let i = 0; i < newTabOpeningExtensions.length; i++) {
      if (thisFileExtension === newTabOpeningExtensions[i]) {
        opensInNewTab = true;
        break;
      }
    }
    this.dataService.getDownloadFileUrl(this.downloadFileModel)
      .subscribe(data => {
        let receivedData = data as any;
        let downloadFileLink = receivedData.presigned_URL;
        if (opensInNewTab) {
          this.dataService.downloadFile(downloadFileLink, filename);
        }
        else {
          this.dataService.forceDownload(downloadFileLink, filename);
        }
        setTimeout(() => {
          this.showDownloadSpinner = false;
          this.downloadingFileStatus = `Download of ${filename} started`;
          this.downloadSuccess = true;
        }, 2000);
      })
  }
  downloadAllFiles(allFiles) {
    let orderIdWithoutHyphens = this.clickedOrderId.split('-').join('');
    this.downloadIndividualFiles(`${orderIdWithoutHyphens}.zip`);
  }
  processReceivedDataAfterUpload(data) {
    let fileUploader = document.querySelector('input[type="file"]') as any;
    let fileName = fileUploader.files[0].name;
    let file = fileUploader.files[0];
    let fileObject = {} as any;
    fileObject['file'] = [fileName, file];
    let mainData = {} as any;
    mainData.AWSAccessKeyId = data.AWSAccessKeyId;
    mainData.key = data.key;
    mainData.policy = data.policy;
    mainData.signature = data.signature;
    this.secondUploadData = file;
    // this.secondUploadData.files = fileObject;
  }
  showOrderModal() {
    this.showModal = true;
    this.orderSuccess = false;
    const numOfOrdersDropdown = document.getElementById('numOfOrdersDropdown') as any;
    numOfOrdersDropdown.querySelectorAll('sh-menu-item').forEach(menuItem => {
      menuItem.active = false;
    });
    this.selectedNumberOfOrders = '1';
    this.firstMenuItemActive = true;
    setTimeout(() => {
      let infoDiv = document.getElementById("order-hints");
      infoDiv.scrollIntoView();
    }, 300);
  }

  restoreVisibility() {
    this.selectedRegions='';
    this.showModal = false;
    this.extendOrder = false;
  }

  restoreOrderConfirmationModals() {
    this.orderSuccess = false;
    this.orderFailed = false;
    this.extensionsucess = false;
  }

  extendHeightOfModal(element) {
    let editModal = document.querySelector('.edit-order-modal') as any
    if (element.tagName.toLowerCase() == "sh-timepicker") {
      if (element.active == true)
        editModal.modalHeight = "80%"
      else
        editModal.modalHeight = "fit-content"
    }
    else {
      if (element.active == true)
        editModal.modalHeight = "98%"
      else
        editModal.modalHeight = "fit-content"
    }

  }

  extendOrTerminate(element) {
    if (element.label === "Extend") {
      this.extendOrTerminateLabel = "Extend";
      this.isExtend = true;
    }
    else {
      this.extendOrTerminateLabel = "Terminate";
      this.isExtend = false;
    }
  }

  checkSwitchLabel(element) {
    var self = this as any;
    if (element.active == true) {
      this.disableDropdown = false;
      let dropdown = document.querySelector(".version-selector") as any;
      dropdown.value = "";
      if (element.label == "PET") {
        this.specificMachineVersionArray = this.PETArray;
        this.selMachine = "PET";
      }
      else if (element.label == "SPECT") {
        this.specificMachineVersionArray = this.SPECTArray;
        this.selMachine = "SPECT"
      }
      else {
        this.specificMachineVersionArray = this.PREVIEWArray;
        this.selMachine = "PREVIEW"
      }
    }
  }

  startTimer() {
    /**
     *
     *  On status call, make inactivecopy = inactive
     *  and activecopy = active.
     *  Create order id array from activecopy.
     *  Extract mail, password and order id array.
     *  if(mail, password exists and order id array length != 0) , check status
     *    split to active and inactive orders
     *      add inactive to inactive orders
     *      remove inactive from active orders
     *      update active orders
     *
     *  make inactivecopy = inactive and activecopy = active.
     */



    // this.orderIdArray = this.createActiveOrderIdArray(this.activeTableData);

    // this.statusModel.mail = this.usermail;
    // this.statusModel.passw = this.userPassword;
    // this.statusModel.orders = this.orderIdArray;

    // if (this.statusModel.mail !== "" && this.statusModel.passw !== "" && this.statusModel.orders.length !== 0 && this.statusModel.orders !== undefined) {

    //   let self = this;
    //   this.dataService.status(self.statusModel)
    //     .subscribe(data => {
    //       let receivedData = data as any;
    //       let localTotalArray = self.statusInactiveActiveSplit(receivedData.orders);
    //       self.activeTableData = localTotalArray[0];
    //       self.inactiveTableData = localTotalArray[1];
    //       self.inactiveTableDataCopy = JSON.parse(JSON.stringify(self.inactiveTableData));
    //       self.activeTableDataCopy = JSON.parse(JSON.stringify(self.activeTableData));
    //       self.inactiveTableDataCopy = this.utcToLocalTimeArray(self.inactiveTableDataCopy);
    //       self.activeTableDataCopy = this.utcToLocalTimeArray(self.activeTableDataCopy);
    //       // console.log('Within status function')
    //       // console.log(self.activeTableData);
    //       // console.log(self.inactiveTableData);
    //       // console.log(self);
    //     },
    //       error => {
    //         //console.log('error');
    //       })
    // }
    // else if (this.activeTableData.length == 0) {
    //   //console.log('No Active Orders');
    //   //console.log(new Date())
    // }
    // // this.activeTableDataCopy = this.activeTableData;
    // // this.inactiveTableDataCopy = this.inactiveTableData;
    this.repeatedStatusCheckModel.passw = this.dataService.loginData.passw;
    this.repeatedStatusCheckModel.mail = this.dataService.loginData.umail;
    this.dataService.login(this.repeatedStatusCheckModel).
      subscribe(data => {
        const receivedData = data as any;
        this.tableData = receivedData.user.orders;
        this.formatDisplayTables(this.tableData);
      })
  }
  formatDisplayTables(tableData) {
    let rawTable = this.tableData;
    /**
    *
    *  Split the array to active and inactive arrays. The function itself assigns the
    *  values to class members activeTableData and inactiveTableData.
    *
   **/

    this.initialActiveInactiveSplit(rawTable);

    // Create copies of these arrays for visual manipulation.

    let localActive = JSON.parse(JSON.stringify(this.activeTableData));
    let localInactive = JSON.parse(JSON.stringify(this.inactiveTableData));

    let formattedActiveArray = JSON.parse(JSON.stringify(this.utcToLocalTimeArray(localActive)));
    let formattedInactiveArray = JSON.parse(JSON.stringify(this.utcToLocalTimeArray(localInactive)));

    // console.log(localActive);
    // console.log(formattedActiveArray);
    let stringifiedFormattedActiveArray = JSON.stringify(formattedActiveArray);
    let stringifiedFormattedInactiveArray = JSON.stringify(formattedInactiveArray);
    let stringifiedActiveTableDataCopy = JSON.stringify(this.activeTableDataCopy);
    let stringifiedInactiveTableDataCopy = JSON.stringify(this.inactiveTableDataCopy);
    if (stringifiedFormattedActiveArray !== stringifiedActiveTableDataCopy) {
      this.activeTableDataCopy = JSON.parse(JSON.stringify(formattedActiveArray));
      // console.log('active table updated');
    }
    if (stringifiedFormattedInactiveArray !== stringifiedInactiveTableDataCopy) {
      this.inactiveTableDataCopy = JSON.parse(JSON.stringify(formattedInactiveArray));
      // console.log('inactive table updated');
    }
  }
  /**
   * Extension / Termination of orders logic
   * IF BUTTON IS TERMINATE
   *  a) show the spinner
   *  b) populate terminateModel object properties
   *    i) terminateModel contains mail, passw, order_id
   *
  **/
  ExtendOrTerminate(button) {
    this.editModalHeading = '';
    if (button.label == "Terminate") {
      this.deleteOrderLoader = true;
      this.extendTerminateLoaderMessage = "Deleting Order...";
      //console.log('terminate')
      this.terminateModel.mail = this.usermail;
      this.terminateModel.passw = this.userPassword;
      this.terminateModel.order_id = this.updatingOrderId;
      this.subscription.unsubscribe();
      this.dataService.terminate(this.terminateModel)
        .subscribe(data => {
          setTimeout(() => {
            this.startTimer();
            setTimeout(() => {
              this.restoreVisibility();
              this.deleteOrderLoader = false;
              this.extensionsucess = true;
              this.extensionTerminationMessage = 'Termination Successful !';
              this.extensionFailReasonMessage = '';
              this.editModalHeading = "Termination Status";
              this.subscription = this.dataService.source.subscribe(n => {
                this.startTimer();
              })
            }, 8000);
          }, 6000);
        },
          error => {
            this.extensionsucess = true;
            this.editModalHeading = "Termination Status"
            this.extensionTerminationMessage = 'Termination failed !';
            this.extensionFailReasonMessage = '';
            this.startTimer();
            this.subscription = this.dataService.source.subscribe(n => {
              this.startTimer();
            })
          })

    }
    else {
      let extendTime = document.querySelector('.extend-time') as any;
      let extendDate = document.querySelector('.extend-date');
      let date = this.updatingOrderEndTimeDate as any;
      let extendedDate = this.convertToDate(extendTime, extendDate) as any;
      this.localExtensionTime = this.getLocalFormatOfDate(extendedDate);
      let delT = Number(extendedDate - date);
      if (((delT / 1000) > 1800) && ((delT / 1000) <= 10800)) {
        this.extendTerminateLoaderMessage = "Extending Order...";
        this.deleteOrderLoader = true;
        let extendUTC = this.convertToUTC(extendTime, extendDate);
        this.extendModel.mail = this.usermail;
        this.extendModel.passw = this.userPassword;
        this.extendModel.order_id = this.updatingOrderId;
        this.extendModel.term_time = extendUTC;
        this.extendModel.local_term_time = this.localExtensionTime;
        this.subscription.unsubscribe();
        this.dataService.extend(this.extendModel)
          .subscribe(data => {
            //console.log(data);

            // this.restoreVisibility();
            this.startTimer();
            setTimeout(() => {
              this.deleteOrderLoader = false;
              this.restoreVisibility();
              this.extensionsucess = true;
              this.editModalHeading = "Extension Status"
              this.extensionTerminationMessage = 'Extension Successful !';
              this.extensionFailReasonMessage = '';
              this.subscription = this.dataService.source.subscribe(n => {
                this.startTimer();
              })
            }, 5000)
          },
            error => {
              this.extensionsucess = true;
              this.editModalHeading = "Extension Status"
              this.extensionTerminationMessage = 'Extension failed !';
              this.extensionFailReasonMessage = '';
              this.startTimer();
              this.subscription = this.dataService.source.subscribe(n => {
                this.startTimer();
              })
            })
      }
      else {
        this.extensionsucess = true;
        this.editModalHeading = "Extension Status"
        if ((delT / 1000) < 1800) {
          this.extensionTerminationMessage = "Extension failed !";
          this.extensionFailReasonMessage = "Extension time must be atleast 30 mins from current order's End time"
        }
        if ((delT / 1000) > 10800) {
          this.extensionTerminationMessage = "Extension failed !";
          this.extensionFailReasonMessage = "Extension time must be less than or equal to 3 hours from current order's End time"
        }
      }
    }
  }

  order() {
    this.OrderingModalSpinner = true;
    let sessionTime = document.querySelector('.session-timepicker') as any;
    let sessionDate = document.querySelector('.session-datepicker') as any;
    let endTime = document.querySelector('.end-timepicker') as any;
    let endDate = document.querySelector('.end-datepicker') as any;
    let sessionUTC = this.convertToUTC(sessionTime, sessionDate) as any;
    let endUTC = this.convertToUTC(endTime, endDate);

    let CalculatedSessionTime = this.convertToDate(sessionTime, sessionDate) as any;
    let CalculatedEndTime = this.convertToDate(endTime, endDate) as any;
    let currentDate = new Date() as any;
    /* Current Order Date in UTC */
    this.orderPresentTime = moment(currentDate).utc().format('YYYY-MM-DD HH:mm:ss');
    /* Local times of Current, Provision and Termination */
    this.localOrderTime = this.getLocalFormatOfDate(currentDate);
    this.localProvisionTime = this.getLocalFormatOfDate(CalculatedSessionTime);
    this.localTerminationTime = this.getLocalFormatOfDate(CalculatedEndTime);

    this.sessionSelectionErrorMessage = '';
    this.endSelectionErrorMessage = '';
    this.generalMessage = '';

    this.sessionSelectionError = false;
    this.endSelectionError = false;
    this.generalError = false;

    if (((CalculatedSessionTime - currentDate) / 1000) <= 3600) {
      this.sessionSelectionError = true;
      this.sessionSelectionErrorMessage = 'Start time must be atleast 1 hour from current time';
      this.generalError = false;
      this.generalMessage = '';
      this.sessionTimeOK = false;
    }
    else {
      this.sessionSelectionError = false;
      this.sessionSelectionErrorMessage = '';
      this.sessionTimeOK = true
    }
    // Extending booking time to 9 hrs maximum - updated on : 22-07-2022 (ui)
    if ((((CalculatedEndTime - CalculatedSessionTime) / 1000) < 7200) || (((CalculatedEndTime - CalculatedSessionTime) / 1000) >= 32400)) {
      this.endSelectionError = true;
      if (((CalculatedEndTime - CalculatedSessionTime) / 1000) < 7200)
        this.endSelectionErrorMessage = 'End Time must be atleast 2 hours after start time';
      else
        this.endSelectionErrorMessage = 'End Time must be less than 9 hours from start time';
      this.generalMessage = '';
      this.generalError = false;
      this.endTimeOk = false;
    }
    else {
      this.endSelectionError = false;
      this.endSelectionErrorMessage = '';
      this.endTimeOk = true;
    }

    if (sessionUTC === "Invalid date" || endUTC === "Invalid date") {
      this.sessionTimeOK = false;
      this.endTimeOk = false;
    }

    let dropDown = document.querySelector('.version-selector') as any;
    let value = dropDown.value;
    let cfg = this.selMachine + "_" + value;

    /* Setting up the orderingModel object */
    this.orderingModel.mail = this.usermail;
    this.orderingModel.passw = this.userPassword;
    this.orderingModel.cfg = cfg;
    this.orderingModel.user_id = this.dataService.loginData.uid;
    this.orderingModel.prov_time = sessionUTC;
    this.orderingModel.term_time = endUTC;
    this.orderingModel.order_time = this.orderPresentTime;
    this.orderingModel.local_order_time = this.localOrderTime;
    this.orderingModel.local_prov_time = this.localProvisionTime;
    this.orderingModel.local_term_time = this.localTerminationTime;
    this.orderingModel.nos = this.selectedNumberOfOrders;
    this.orderingModel.region = this.selectedRegions;
    if( this.orderingModel.region == ''){
      this.orderingModel.region = 'N.Virginia';
    }

    if (cfg !== "undefined_" && cfg !== "SPECT_" && cfg !== "PET_" && (this.sessionTimeOK) && (this.endTimeOk)) {
      this.generalError = false;
      this.generalMessage = '';
      this.subscription.unsubscribe();
      this.dataService.order(this.orderingModel)
        .subscribe(data => {
          let receivedData = data as any;

          // this.activeTableData.push(receivedData.order);

          this.startTimer();
          setTimeout(() => {
            this.orderFailed = false;
            this.orderSuccess = true;
            this.OrderingModalSpinner = false;
            this.restoreVisibility();
            this.subscription = this.dataService.source.subscribe(n => {
              this.startTimer();
            })
          }, 5000);
        },
          error => {
            this.orderFailed = true;
            this.orderSuccess = false;
            this.OrderingModalSpinner = false;
            this.startTimer();
            this.subscription = this.dataService.source.subscribe(n => {
              this.startTimer();
            })
          })

    }
    else {
      // this.subscription.unsubscribe();
      this.orderFailed = true;
      let stringArray = ['start time and start date', 'end time and end date', 'software version', 'specific PET version', 'specific SPECT version'];
      this.generalError = true;
      this.generalMessage = 'Please enter '
      if (sessionUTC === "Invalid date") {
        this.generalMessage += stringArray[0] + ", "
      }
      if (endUTC === "Invalid date") {
        this.generalMessage += stringArray[1] + ", "
      }
      if (cfg === "undefined_") {
        this.generalMessage += stringArray[2] + ""
      }
      if (cfg === "PET_") {
        this.generalMessage += stringArray[3] + ""
      }
      if (cfg === "SPECT_") {
        this.generalMessage += stringArray[4] + ""
      }
      this.orderSuccess = false;
      this.OrderingModalSpinner = false;
    }
    // this.subscription.unsubscribe();


  }

  convertToDate(localTime, localDate) {
    let date = new Date();
    let lHour, lMin, lSec, lMonth, lYear, lDate, lAMPM;
    lHour = localTime.h;
    lMin = localTime.m;
    lSec = localTime.s;
    lAMPM = localTime.amPm;
    let localDateArray = localDate.value.split('/');
    lMonth = (Number(localDateArray[0]) - 1);
    lYear = (Number(localDateArray[2]));
    lDate = (Number(localDateArray[1]));

    if (lAMPM == "PM" && Number(lHour) !== 12) {
      lHour = Number(lHour) + 12;
    }
    else if (lAMPM == "PM" && Number(lHour) == 12) {
      lHour = 12
    }
    else if (lAMPM == "AM" && Number(lHour) == 12) {
      lHour = 0;
    }
    date.setHours(lHour);
    date.setMinutes(lMin);
    date.setSeconds(lSec);
    date.setMonth(lMonth);
    date.setFullYear(lYear);
    date.setDate(lDate);
    return date;
  }

  utcToLocalFormat(utc) {
    var local_date = moment.utc(utc).local().format('MMMM D YYYY, hh:mm:ss a');
    return local_date;
  }

  convertToUTC(localTime, localDate) {
    let date = new Date();
    let lHour, lMin, lSec, lMonth, lYear, lDate, lAMPM;
    lHour = localTime.h;
    lMin = localTime.m;
    lSec = localTime.s;
    lAMPM = localTime.amPm;
    let localDateArray = localDate.value.split('/');
    lMonth = (Number(localDateArray[0]) - 1);
    lYear = (Number(localDateArray[2]));
    lDate = (Number(localDateArray[1]));

    if (lAMPM == "PM" && Number(lHour) !== 12) {
      lHour = Number(lHour) + 12;
    }
    else if (lAMPM == "PM" && Number(lHour) == 12) {
      lHour = 12
    }
    else if (lAMPM == "AM" && Number(lHour) == 12) {
      lHour = 0;
    }
    date.setHours(lHour);
    date.setMinutes(lMin);
    date.setSeconds(lSec);
    date.setMonth(lMonth);
    date.setFullYear(lYear);
    date.setDate(lDate);
    date.toUTCString();
    let UTCdate = moment(date).utc().format('YYYY-MM-DD HH:mm:ss');
    return UTCdate;
  }

  initialActiveInactiveSplit(orders) {
    this.activeTableData = [];
    this.inactiveTableData = [];
    for (let i = 0; i < orders.length; i++) {
      let oneOrder = orders[i];
      for (let subItem in oneOrder) {
        if (subItem.toString() === "Progress") {
          if (oneOrder[subItem] === "Elapsed" || oneOrder[subItem] === "Ended" || oneOrder[subItem] === "Cancelled") {
            this.inactiveTableData.push(oneOrder);
          }
          else {
            if (localStorage.getItem('userList')) {
              let data = JSON.parse(localStorage.getItem('userList'));
              if (data.length > 0) {
                data.forEach(element => {
                  if (element.id === oneOrder.id) {
                    if (element.value) {
                      oneOrder['goal'] = element.value;
                    }
                  }
                });
              }
            }
            this.activeTableData.push(oneOrder);
          }
          if (oneOrder[subItem] === 'Not-Started') {
            oneOrder.connectDisabled = true;
          }
          else {
            oneOrder.connectDisabled = false;
          }
          if (oneOrder[subItem] === "Deprovisioning" || oneOrder[subItem] === "Started") {
            oneOrder.disableUpdateBtn = true;
            oneOrder.connectDisabled = true;
          }
          else if (oneOrder[subItem] === 'Not-Started') {
            oneOrder.disableUpdateBtn = false;
            oneOrder.connectDisabled = true;
          }
          else {
            oneOrder.disableUpdateBtn = false;
            oneOrder.connectDisabled = false;
          }

        }
      }
    }
  }

  deepCopy(obj) {
    if (Object.prototype.toString.call(obj) === '[object Array]') {
      let out: any;
      out = []; var i = 0, len = obj.length;
      for (; i < len; i++) {
        out[i] = arguments.callee(obj[i]);
      }
      return out;
    }
    if (typeof obj === 'object') {
      let out = {}, i;
      for (i in obj) {
        out[i] = arguments.callee(obj[i]);
      }
      return out;
    }
    return obj;
  }

  removeOrderFromActiveArray(orderObject) {
    /**
     *
     * Receives one inactive order object. If that order object is present in active Table data array, remove that object.
     * Copy this value of new active table data to its copy variable
     *
     */
    let origActiveArray = this.activeTableData;
    for (let i = 0; i < origActiveArray.length; i++) {
      let eachOrderObject = origActiveArray[i];
      if (eachOrderObject['id'] === orderObject['id']) {
        origActiveArray.splice(i, 1);
      }
    }
    // this.activeTableData = origActiveArray;
    // this.activeTableDataCopy = this.activeTableData;
    return origActiveArray;
  }

  // checkForUpdates(orderObject) {
  //   let origActiveArray = this.activeTableData;
  //   for (let i = 0; i < origActiveArray.length; i++) {
  //     let eachOrderObject = origActiveArray[i];
  //     if (eachOrderObject['id'] === orderObject['id']) {
  //       eachOrderObject['End_time'] = orderObject['End_time'];
  //       eachOrderObject['Progress'] = orderObject['Progress'];
  //       eachOrderObject['Session_time'] = orderObject['Session_time'];
  //       eachOrderObject['TimeStamp'] = orderObject['TimeStamp'];
  //       eachOrderObject['cfg'] = orderObject['cfg'];
  //       eachOrderObject['node_id'] = orderObject['node_id'];
  //       eachOrderObject['user_id'] = orderObject['user_id'];
  //       if (eachOrderObject['Progress'] === "Deprovisioning" || eachOrderObject['Progress'] === "Started") {
  //         eachOrderObject.disableUpdateBtn = true;
  //       }
  //       else {
  //         eachOrderObject.disableUpdateBtn = false;
  //       }
  //       origActiveArray[i] = eachOrderObject;
  //     }
  //   }
  //   // this.activeTableData = origActiveArray;
  //   // console.log('ACTIVE TABLE DATA AFTER CHECKING FOR UPDATES')
  //   // console.log(this.activeTableData);
  //   return origActiveArray;
  // }

  // statusInactiveActiveSplit(orders) {
  //   /**
  //    *
  //    *  If orders have progress as elapsed, ended or cancelled, then push that particular order to inactive orders.
  //    *  Remove the inactive order from the active order list.
  //    *  Remove the inactive order from the order id array.
  //    *  If the order is an active order, check for updates of each order in the active table data array
  //    *
  //    */
  //   let localActiveArray = [];
  //   let localInactiveArray = [];
  //   let localTotalArray = [];
  //   localActiveArray = this.activeTableData;
  //   localInactiveArray = this.inactiveTableData;
  //   for (let i = 0; i < orders.length; i++) {
  //     let oneOrder = orders[i];
  //     for (let subItem in oneOrder) {
  //       if (subItem.toString() === "Progress") {
  //         if (oneOrder[subItem] === "Elapsed" || oneOrder[subItem] === "Ended" || oneOrder[subItem] === "Cancelled") {
  //           localInactiveArray.push(oneOrder);
  //           // this.inactiveTableDataCopy = this.inactiveTableData;
  //           // this.inactiveTableDataCopy = this.utcToLocalTimeArray(this.inactiveTableDataCopy);
  //           localActiveArray = this.removeOrderFromActiveArray(oneOrder)
  //           // let indexToBeRemoved = i;
  //           // orders.splice(indexToBeRemoved,1);
  //         }
  //         else {
  //           localActiveArray = this.checkForUpdates(oneOrder)
  //           if (oneOrder[subItem] === "Deprovisioning" || oneOrder[subItem] === "Started") {
  //             oneOrder.disableUpdateBtn = true;
  //           }
  //           else {
  //             oneOrder.disableUpdateBtn = false;
  //           }
  //         }
  //       }
  //     }
  //   }
  //   // this.orderIdArray = this.createActiveOrderIdArray(orders);
  //   // console.log('Order ID Array : ' + this.orderIdArray);
  //   // console.log(orders);
  //   localTotalArray[0] = localActiveArray;
  //   localTotalArray[1] = localInactiveArray;
  //   // console.log(localTotalArray)
  //   return localTotalArray;
  // }

  utcToLocalTimeArray(tableArray) {
    for (let i = 0; i < tableArray.length; i++) {
      let oneOrderObject = tableArray[i];
      for (let property in oneOrderObject) {
        let propertyName = property.toString();
        if (propertyName === "End_time" || propertyName === "Session_time") {
          oneOrderObject[property] = this.utcToLocalFormat(oneOrderObject[property]);
        }
      }
    }
    let array1 = tableArray.splice(0);
    return array1;
  }

  createActiveOrderIdArray(activeTableData) {
    let idArray = [];
    for (let i = 0; i < activeTableData.length; i++) {
      let oneOrderObject = activeTableData[i];
      for (let property in oneOrderObject) {
        let propertyName = property.toString();
        if (propertyName === "id") {
          idArray.push(oneOrderObject[property]);
        }
      }
    }
    return idArray;
  }
  displayAppropriateTable(label, active) {
    // let inactiveTable = document.querySelector('.inactiveTableOrderDiv') as any;
    // let activeTable = document.querySelector('.activeTableOrderDiv') as any;
    if (active) {
      if (label === 'Active Orders') {
        document.documentElement.style.setProperty('--displayActiveTable', 'initial');
        document.documentElement.style.setProperty('--displayInactiveTable', 'none');
      }
      else {
        document.documentElement.style.setProperty('--displayInactiveTable', 'initial');
        document.documentElement.style.setProperty('--displayActiveTable', 'none');
      }
    }
  }
  openHiddenDrawer(data, id) {
    let drawer = document.querySelector('.update-drawer') as any;
    drawer.visible = false;
    let idHTML = "<b>Serial No: </b> " + (id + 1);
    let dataIdHTML = "<b>Order Id:</b> " + data.id;
    let softVersionHTML = "<b>Software Version:</b> " + data.cfg;
    let progressHTML = "<b>Progress: </b>" + data.Progress;
    let sessionHTML = "<b>Session Time: </b>" + data.Session_time;
    let endHTML = "<b>End Time: </b>" + data.End_time;

    let childTexts = drawer.querySelectorAll('sh-text');
    childTexts[0].innerHTML = idHTML;
    childTexts[1].innerHTML = dataIdHTML;
    childTexts[2].innerHTML = softVersionHTML;
    childTexts[3].innerHTML = progressHTML;
    childTexts[4].innerHTML = sessionHTML;
    childTexts[5].innerHTML = endHTML;

    drawer.visible = true;

    this.mobileTableRowId = data.id;
    this.mobileTableRowEndTime = data.End_time;
  }

  toggleTables(tabItem) {
    let activeMobileTable = document.querySelector('.active-mobile-table') as any;
    let inactiveMobileTable = document.querySelector('.inactive-mobile-table') as any;

    if (tabItem.label === "Active Orders") {
      activeMobileTable.style.display = "block";
      inactiveMobileTable.style.display = "none";
    }
    else if (tabItem.label === "Inactive Orders") {
      inactiveMobileTable.style.display = "block";
      activeMobileTable.style.display = "none";
    }
  }

  switchTheme(e) {
    const self = this;
    setTimeout(() => {
      if (e.target.id === "themeSwitcherIcon") {
        if (self.theme === "dark") {
          self.dataService.theme = "light";
        }
        else {
          self.dataService.theme = "dark";
        }
      }
      else {
        if (e.target.active) {
          self.dataService.theme = "dark";
        }
        else {
          self.dataService.theme = "light";
        }
      }
      self.theme = self.dataService.theme;
    }, 300);
  }

  showLeftDrawer() {
    let drawer = document.getElementById('drawer-left') as any;
    drawer.visible = true;
  }

  getLocalFormatOfDate(d) {
    /* Convert date to YYYY-MM-DD HH:mm:ss z where z stands for timezone eg: (Indian Standard Time) */
    let stringFormat = d.toString();
    let gmtOnwards = stringFormat.substring(stringFormat.indexOf('G'));
    let timeZoneAlone = gmtOnwards.substring(gmtOnwards.indexOf('('));
    let dateFormat = moment(d).format('YYYY-MM-DD HH:mm:ss ');
    let requiredFormat = dateFormat + timeZoneAlone;
    return requiredFormat;
  }

  // setTarget(){
  //   document.querySelector('popover#theme-switcher').setAttribute('target','themeSelector')
  // }

  reloadPage() {
    window.location.reload();
  }
  uncheckAllOrderEditOptions() {
    for (let i = 0; i < this.orderEditOption.length; i++) {
      this.orderEditOption[i] = false;
    }
  }
  connectToVM(orderId) {
    this.orderEditModal = false;
    this.connectModalDialog = true;
    this.connectModalDialogVisible = true;
    this.connectModalDialogMessageObtained = false;
    this.connectModalMessage = ``;
    this.connectModalURL = ``;
    this.intermediateConnectModalMessage = ``;
    this.connectVMData.mail = this.usermail;
    this.connectVMData.passw = this.userPassword;
    this.connectVMData.order_id = orderId;
    this.connectModalDialogError = false;
    this.dataService.connectVM(this.connectVMData)
      .subscribe(data => {
        let receivedData = data as any;
        this.connectModalDialogMessageObtained = true;
        this.connectModalMessage = `Here is the URL for the VM :
      `;
        this.connectModalURL = `${receivedData.url}`;
        // let pseudoVMLink = document.createElement('a');
        // pseudoVMLink.setAttribute('target','_blank');
        // pseudoVMLink.href = this.connectModalURL;
        // let countDownTimerCount = 10;
        // let countDownTimer = setInterval(()=> {
        //   this.intermediateConnectModalMessage = `Redirecting in ${countDownTimerCount}s ...`;
        //   --countDownTimerCount;
        // }, 1000)
        // let setTimer = setTimeout(() => {
        //   // pseudoVMLink.click();
        //   // clearInterval(countDownTimer);
        //   clearTimeout(setTimer);
        //   this.intermediateConnectModalMessage = ``;
        // //   this.connectModalMessage = `The VM URL is opened in a new tab.
        // // You may also copy the URL below manually

        // // If a new tab is not opened, you may have to enable popup for this site`;
        // }, 11000);
      },
        error => {
          this.connectModalDialogError = true;
          this.connectModalMessage = 'Unexpected Error. Please try again'
          this.connectModalDialogMessageObtained = true;
          if (error.status === 0) {
            this.connectModalMessage = "No Internet connection";
          }
        })

  }
  ngOnInit() {
    /**
     *
     *  If user has refreshed the browser, it must go back to login page.
     *
    **/



    if (!this.dataService.loginAuthorized) {
      this.router.navigateByUrl('');
    }

    /**
     *  Select Theme
     *
     */
    this.theme = this.dataService.theme;
    let allThemeToggles = document.querySelectorAll('.theme-switcher-toggle') as any;
    let numberOfThemeToggles = allThemeToggles.length;
    for (let i = 0; i < numberOfThemeToggles; i++) {
      if (this.dataService.theme === "dark") {
        allThemeToggles[i].active = true;
      }
      else {
        allThemeToggles[i].active = false;
      }
    }
    // this.theme = this.dataService.theme;

    // let darkSwitchMobile = document.getElementById("darkSwitchMobile") as any;
    // let lightSwitchMobile = document.getElementById("lightSwitchMobile") as any;
    // if(this.theme === "light") {
    //   lightSwitchMobile.active = true;
    //   darkSwitchMobile.active = false;
    // }
    // else {
    //   darkSwitchMobile.active = true;
    //   lightSwitchMobile.active = false;
    // }

    /**
     *
     *  Capture the username, email and password from dataService.loginData
     *
    **/
    this.loggedUser = this.dataService.loginData.uname;
    this.usermail = this.dataService.loginData.umail;
    this.userPassword = this.dataService.loginData.passw;

    /**
     *
     *  Get the table-data from dataService.loginData.orders. Copy that to local variable called rawTable.
     *
    **/

    this.tableData = this.dataService.loginData.orders as any;
    this.tableData = this.tableData
    let rawTable = this.tableData

    /**
     *
     *  Split the array to active and inactive arrays. The function itself assigns the
     *  values to class members activeTableData and inactiveTableData.
     *
    **/

    this.initialActiveInactiveSplit(rawTable);

    // Create copies of these arrays for visual manipulation.

    let localActive = JSON.parse(JSON.stringify(this.activeTableData));
    let localInactive = JSON.parse(JSON.stringify(this.inactiveTableData));

    let formattedActiveArray = JSON.parse(JSON.stringify(this.utcToLocalTimeArray(localActive)));
    let formattedInactiveArray = JSON.parse(JSON.stringify(this.utcToLocalTimeArray(localInactive)));

    // console.log(localActive);
    // console.log(formattedActiveArray);

    this.activeTableDataCopy = JSON.parse(JSON.stringify(formattedActiveArray));
    this.inactiveTableDataCopy = JSON.parse(JSON.stringify(formattedInactiveArray));

    // Convert the session time and end time of these local copies to local time format

    // localActive = this.utcToLocalTimeArray(localActive)
    // localInactive = this.utcToLocalTimeArray(localInactive)

    // this.activeTableDataCopy = JSON.parse(JSON.stringify(this.utcToLocalTimeArray(localActive)));
    // this.inactiveTableDataCopy = JSON.parse(JSON.stringify(this.utcToLocalTimeArray(localInactive)));


    // console.log(this.activeTableDataCopy);

    /**
     *
     *  We will be displaying these time formatted copies as our tables, while safely storing our original data elsewhere.
     *
    **/

    /**
     *
     *  Creating an array of strings of active order-id's
     *
    **/

    this.orderIdArray = this.createActiveOrderIdArray(this.activeTableDataCopy)

    /**
     *
     *  Storing mail, password and  active order-id array as properties of statusModel object for checking status for the first
     *  time.
     *
    **/

    this.statusModel.mail = this.usermail;
    this.statusModel.passw = this.userPassword;
    this.statusModel.orders = this.orderIdArray;

    /**
     *
     * Starting the status check call. It is started by starting an 'interval' service called 'source' located in dataService
     *
     */
    // console.log('#########################')
    // console.log(this.activeTableData);
    // console.log(this.activeTableDataCopy);
    // console.log(this.inactiveTableData)
    // console.log(this.inactiveTableDataCopy);
    // console.log('#########################')

    this.subscription = this.dataService.source.subscribe(n => {
      this.startTimer();
    })
    // this.warningIssueTimer = this.dataService.warningCheck.subscribe(n => {
    //   this.warningIssueTime();
    // })

    /**
     *
     *  We would like to populate the dropdown initially with various versions of either PET or SPECT. For that we do the following looping.
     *  Since this is used only once per visit to home-page, no function is required
     *
     */

    this.dataService.requestSoftwareVersion({ mail: sessionStorage.getItem('mail') }).subscribe(data => {
      this.machines = data;
      let machineArray = this.machines;

      for (let counter = 0; counter < machineArray.length; counter++) {
        let singleMachineVersion = machineArray[counter];
        let machineHasPET = (singleMachineVersion.search(/PET/i) != -1) ? true : false;
        let machineHasSPECT = (singleMachineVersion.search(/SPECT/i) != -1) ? true : false;
        //Removed this as Denali is now under SPECT
        //let isPreview = singleMachineVersion.toLowerCase().indexOf("preview") != -1;
        if (machineHasPET) {
          this.PETArray.push(singleMachineVersion.split('_')[1]);
        }
        // else if (isPreview) {
        //   if(singleMachineVersion.toLowerCase()!=('PREVIEW_Denali').toLowerCase()){ //to remove this from dropdown
        //     this.PREVIEWArray.push(singleMachineVersion.split('_')[1]);
        //   }
        // }
        else if (machineHasSPECT) {
          this.SPECTArray.push(singleMachineVersion.split('_')[1]);
        }
      }
    })

    if (window.innerWidth < 767) {
      this.mobileView = true;
      this.tooltipPosition = "top";
      this.uploadFileModalWidth = '100%';
      this.uploadFileModalHeight = '100%';
    }
    else {
      this.mobileView = false;
      this.tooltipPosition = "bottom";
      this.uploadFileModalWidth = '624px';
      this.uploadFileModalHeight = '400px';
    }
  }

  ngOnDestroy() {
    /**
     *
     *  On destroying , the 'source' must be unsubscribed, else, it will still continue to count through , even the next time when home-page is visited.
     *  Basically, the timer is stopped here.
     *
     */
    this.subscription.unsubscribe();
    // this.warningIssueTimer.unsubscribe();
  }
  vewAllMacines(activeOrder: any) {
    let complitedOrder = activeOrder.filter(function (x) {
      return x.Progress === 'Completed';
    });
    if (complitedOrder) {
      this.ordersForIframe = complitedOrder;
      this.showAllMachine = true;
    }
    else {
      alert('Sorry! No Completed orders are found.');
      return;
    }
  }
  goToHome() {
    this.showAllMachine = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/create-workspace/home/home.component.ts